import styles from "./home-cover.module.css";
import coverImg from "../../../images/_finais/home-cover_compress.webp";
import logoCover from "../../../images/_finais/logo-vertical_compress.webp";

const HomeCover = () => {
  return (
    <section className={styles.cover_section}>
      <div className={styles.logoCover}>
        <img
          className={styles.logo}
          src={logoCover}
          alt="Logo"
          loading="lazy"
        />
      </div>
      <img
        className={styles.coverImg}
        src={coverImg}
        alt="Cover da página Home."
        loading="lazy"
      />
    </section>
  );
};

export default HomeCover;
